// Catalog Product Variants
if ($('#category #product-variants').length > 0) {
  $('#product-variants .circle').on('keypress', function (event) {
    if (event.type === 'keypress' && event.key === 'Enter') {
      var attributeId = $(this).data('attribute-id');
      var input = $(this)
        .closest('.product-variants-item')
        .find('input[value="' + attributeId + '"]');
      if (input.length > 0) {
        input.click();
      }
    }
  });
  $('#product-variants input').on('click', function () {
    var productId = $(this).data('product-id');
    var attributeId = $(this).val();
    var attributeImageSrc = $(this).data('img');
    var attributeUrl = $(this).data('url');
    var quantity = $(this).data('quantity');
    var base_price = $(this).data('base-price');
    var base_price_text = $('.regular-price').data('text');
    var discount_price = $(this).data('discount-price');
    var discount_label = $(this).data('discount-label');
    var omnibus_price = $(this).data('omnibus-price');

    $(
      `.product-miniature[data-id-product="${productId}"] .product-variants-item .circle,
			.product-miniature[data-id-product="${productId}"] .product-variants-item span`,
    ).removeClass('active');

    $(
      `.product-miniature[data-id-product="${productId}"] .product-variants-item .circle[data-attribute-id="${attributeId}"],
			.product-miniature[data-id-product="${productId}"] .product-variants-item span[data-attribute-id="${attributeId}"]`,
    ).addClass('active');

    $(`.product-miniature[data-id-product="${productId}"] .thumbnail-top img,
			.product-miniature[data-id-product="${productId}"] .product-thumb-wrapper img`).attr('src', attributeImageSrc);

    $(
      `.product-miniature[data-id-product="${productId}"] .product-description-button-wrapper a,
			.product-miniature[data-id-product="${productId}"] a.btn-description,
			.product-miniature[data-id-product="${productId}"] a.product-link`,
    ).attr('href', attributeUrl);

    if (quantity > 0) {
      $(`.product-miniature[data-id-product="${productId}"] button[data-button-action="add-to-cart"]`).show();
      $(`.product-miniature[data-id-product="${productId}"] .notify-modal-button`).hide();
    } else {
      $(`.product-miniature[data-id-product="${productId}"] button[data-button-action="add-to-cart"]`).hide();
      $(`.product-miniature[data-id-product="${productId}"] .notify-modal-button`).attr(
        'data-id-attribute',
        attributeId,
      );
      $(`.product-miniature[data-id-product="${productId}"] .notify-modal-button`).show();
    }

    if (base_price != discount_price) {
      $(`.product-miniature[data-id-product="${productId}"] .product-price-and-shipping .price`).html(discount_price);
      $(`.product-miniature[data-id-product="${productId}"] .product-price-and-shipping .regular-price`).html(
        base_price,
      );
      $(`.product-miniature[data-id-product="${productId}"] .product-price-and-shipping .regular-price-text`).html(
        base_price_text,
      );
    } else {
      $(`.product-miniature[data-id-product="${productId}"] .product-price-and-shipping .regular-price`).html(' ');
      $(`.product-miniature[data-id-product="${productId}"] .product-price-and-shipping .regular-price-text`).html(' ');
      $(`.product-miniature[data-id-product="${productId}"] .product-price-and-shipping .price`).html(base_price);
    }

    if (discount_label) {
      $(
        `.product-miniature[data-id-product="${productId}"] .product-flag-wrapper.product-flag-discount .product-flag.discount`,
      ).html(discount_label);
      $(`.product-miniature[data-id-product="${productId}"] .product-flag-wrapper.product-flag-discount`).show();
    } else {
      $(`.product-miniature[data-id-product="${productId}"] .product-flag-wrapper.product-flag-discount`).hide();
    }

    if (omnibus_price) {
      $(`.product-miniature[data-id-product="${productId}"] .omnibusWrapper .omnibusPrice`).html(omnibus_price);
      $(`.product-miniature[data-id-product="${productId}"] .omnibusWrapper`).show();
    } else {
      $(`.product-miniature[data-id-product="${productId}"] .omnibusWrapper`).hide();
    }
  });
}
if ($('#category #product-variants-bundle').length > 0) {
  $(document).on(
    'click keypress',
    '#product-variants-bundle .input-radio, #product-variants-bundle .circle',
    function (event) {
      if (event.type === 'click' || (event.type === 'keypress' && event.key === 'Enter')) {
        let selectedProductId = $(this).closest('label').find('.circle').data('product-id');
        let productIds = [31, 32, 33, 34, 35];

        $('.listing-translators, .listing-product').each(function () {
          let productId = $(this).find('.js-product-miniature').data('id-product');

          if (productId == selectedProductId || !productIds.includes(productId)) {
            $(this).removeClass('hidden').removeAttr('hidden');
          } else {
            $(this).addClass('hidden').attr('hidden', true);
          }
        });

        $('#product-variants-bundle .circle').each(function () {
          let colorProductId = $(this).data('product-id');

          if (colorProductId == selectedProductId) {
            $(this).addClass('active').attr('aria-checked', 'true');
            $(this).closest('label').find('.input-radio').prop('checked', true);
            $(this).closest('label').find('.radio-label').addClass('active');
          } else {
            $(this).removeClass('active').attr('aria-checked', 'false');
            $(this).closest('label').find('.input-radio').prop('checked', false);
            $(this).closest('label').find('.radio-label').removeClass('active');
          }
        });
      }
    },
  );
}
